module.exports = __webpack_public_path__ + "img/first-hdbg.f86469de.png";